<div class="admin-wrapper">
  <app-public-toast />
  <aside class="sidebar">
    <!-- Brand header -->
    <div class="sidebar-header">
      <div class="brand-title">
        <img src="assets/hytec-logo.png" alt="Hytec Logo" class="brand-logo">
        <span class="brand-subtitle">Content Management System</span>
      </div>
    </div>

    <!-- Navigation -->
    <nav class="nav-container">
      <!-- Dashboard -->
      <a routerLink="/admin" routerLinkActive="active-nav-item" [routerLinkActiveOptions]="{ exact: true }"
        class="nav-item">
        <svg xmlns="http://www.w3.org/2000/svg" class="nav-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
        </svg>
        <span class="nav-label">Dashboard</span>
      </a>

      @if (authService.user()?.role === 'super_admin') {
        <a routerLink="/admin/users" routerLinkActive="active-nav-item" class="nav-item nav-item--secondary">
          <svg xmlns="http://www.w3.org/2000/svg" class="nav-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M17 20h5V4H2v16h5m10 0v-2a4 4 0 00-4-4H9a4 4 0 00-4 4v2m12 0H7m10-9a3 3 0 11-6 0 3 3 0 016 0zm-8 0a3 3 0 11-6 0 3 3 0 016 0z" />
          </svg>
          <span class="nav-label">Manage Users</span>
        </a>

        <a routerLink="/admin/visitor-registrations" routerLinkActive="active-nav-item" class="nav-item nav-item--secondary">
          <svg xmlns="http://www.w3.org/2000/svg" class="nav-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M8 7V3m8 4V3m-9 8h10m-11 9h12a2 2 0 002-2V7a2 2 0 00-2-2H6a2 2 0 00-2 2v11a2 2 0 002 2zm3-5h.01M12 14h.01M15 14h.01M9 17h.01M12 17h.01M15 17h.01" />
          </svg>
          <span class="nav-label">Visitor Registrations</span>
        </a>

        <a routerLink="/admin/system-logs" routerLinkActive="active-nav-item" class="nav-item nav-item--secondary">
          <svg xmlns="http://www.w3.org/2000/svg" class="nav-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M9 17v-2m3 2v-4m3 4V7m4 12H5a2 2 0 01-2-2V5a2 2 0 012-2h14a2 2 0 012 2v12a2 2 0 01-2 2z" />
          </svg>
          <span class="nav-label">System Logs</span>
        </a>
      }

      <div class="nav-top-spacer"></div>
      <div class="nav-section-divider"></div>

      <!-- Dynamic nav items -->
      @for (item of navItems; track item.label) {
        @if (!item.children) {
          <a [routerLink]="item.route" routerLinkActive="active-sub-item"
            class="standalone-nav-item">
            {{ item.label }}
          </a>
        } @else {
          <div class="nav-group-wrapper">
            <button class="nav-group-header" [class.group-active]="hasActiveDescendant(item, router.url)"
              (click)="toggleGroup(item)">
              <span>{{ item.label }}</span>
              <svg xmlns="http://www.w3.org/2000/svg" class="chevron" [class.rotated]="item.expanded" fill="none"
                viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
              </svg>
            </button>

            <div class="group-children" [class.open]="item.expanded">
              <div class="sub-nav-list">
                @for (child of item.children; track child.label) {
                  @if (!child.children) {
                    <a [routerLink]="child.route" routerLinkActive="active-sub-item"
                      class="sub-nav-item">
                      {{ child.label }}
                    </a>
                  } @else {
                    <div class="sub-group-wrapper">
                      <button class="sub-nav-group-header" [class.active-sub-group]="hasActiveDescendant(child, router.url)"
                        (click)="toggleGroup(child)">
                        <span>{{ child.label }}</span>
                        <svg xmlns="http://www.w3.org/2000/svg" class="chevron" [class.rotated]="child.expanded" fill="none"
                          viewBox="0 0 24 24" stroke="currentColor">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                        </svg>
                      </button>

                      <div class="group-children" [class.open]="child.expanded">
                        <div class="sub-sub-nav-list">
                          @for (grandchild of child.children; track grandchild.label) {
                            <a [routerLink]="grandchild.route"
                              routerLinkActive="active-sub-sub-item" class="sub-sub-nav-item">
                              {{ grandchild.label }}
                            </a>
                          }
                        </div>
                      </div>
                    </div>
                  }
                }
              </div>
            </div>
          </div>
        }
      }
    </nav>

    <!-- Footer: theme toggle + back to site -->
    <div class="sidebar-footer">
      <button (click)="themeService.toggleTheme()" class="theme-toggle-btn"
        [title]="themeService.darkMode() ? 'Switch to Light Mode' : 'Switch to Dark Mode'" aria-label="Toggle theme">
        <!-- Sun icon — shown in dark mode to switch to light -->
        @if (themeService.darkMode()) {
          <svg xmlns="http://www.w3.org/2000/svg" class="theme-icon" fill="none"
          viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364-6.364l-.707.707M6.343 17.657l-.707.707M17.657 17.657l-.707-.707M6.343 6.343l-.707-.707M12 8a4 4 0 100 8 4 4 0 000-8z" />
          </svg>
        } @else {
        <!-- Moon icon — shown in light mode to switch to dark -->
          <svg xmlns="http://www.w3.org/2000/svg" class="theme-icon" fill="none"
          viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M21 12.79A9 9 0 1111.21 3a7 7 0 009.79 9.79z" />
          </svg>
        }
        <span class="theme-label">
          {{ themeService.darkMode() ? 'Light Mode' : 'Dark Mode' }}
        </span>
      </button>

      <button (click)="logout()" class="back-button" title="Log out">
        <svg xmlns="http://www.w3.org/2000/svg" class="back-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
        </svg>
        Log Out
      </button>
      <a routerLink="/" class="back-button">
        <svg xmlns="http://www.w3.org/2000/svg" class="back-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
        </svg>
        Back to Website
      </a>
    </div>
  </aside>

  <main class="main-viewport">
    <div #adminScrollContainer class="scroll-wrapper">
      <div class="content-container">
        <router-outlet />
      </div>
    </div>
    <back-to-top class="admin-back-to-top" [scrollTarget]="adminScrollContainer" />
  </main>
</div>
